'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var withIs = require('class-is');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var sortLinks = require('./sortLinks');

var DAGLink = require('../dag-link/dagLink');

var _require2 = require('../serialize.js'),
    serializeDAGNode = _require2.serializeDAGNode;

var _toDAGLink = require('./toDagLink');

var _addLink = require('./addLink');

var _rmLink = require('./rmLink');

var DAGNode = /*#__PURE__*/function () {
  function DAGNode(data) {
    var links = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var serializedSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, DAGNode);

    if (!data) {
      data = Buffer.alloc(0);
    }

    if (typeof data === 'string') {
      data = Buffer.from(data);
    }

    if (!Buffer.isBuffer(data)) {
      throw new Error('Passed \'data\' is not a buffer or a string!');
    }

    if (serializedSize !== null && typeof serializedSize !== 'number') {
      throw new Error('Passed \'serializedSize\' must be a number!');
    }

    links = links.map(function (link) {
      return DAGLink.isDAGLink(link) ? link : DAGLink.util.createDagLinkFromB58EncodedHash(link);
    });
    links = sortLinks(links);
    this._data = data;
    this._links = links;
    this._serializedSize = serializedSize;
    this._size = null;
  }

  _createClass(DAGNode, [{
    key: "toJSON",
    value: function toJSON() {
      if (!this._json) {
        this._json = Object.freeze({
          data: this.Data,
          links: this._links.map(function (l) {
            return l.toJSON();
          }),
          size: this.size
        });
      }

      return Object.assign({}, this._json);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "DAGNode <data: \"".concat(this.Data.toString('base64'), "\", links: ").concat(this.Links.length, ", size: ").concat(this.size, ">");
    }
  }, {
    key: "_invalidateCached",
    value: function _invalidateCached() {
      this._serializedSize = null;
      this._size = null;
    }
  }, {
    key: "addLink",
    value: function addLink(link) {
      this._invalidateCached();

      return _addLink(this, link);
    }
  }, {
    key: "rmLink",
    value: function rmLink(link) {
      this._invalidateCached();

      return _rmLink(this, link);
    } // @returns {Promise.<DAGLink>}

  }, {
    key: "toDAGLink",
    value: function toDAGLink(options) {
      return _toDAGLink(this, options);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return serializeDAGNode({
        Data: this._data,
        Links: this._links
      });
    }
  }, {
    key: "size",
    get: function get() {
      if (this._size === null) {
        if (this._serializedSize === null) {
          this._serializedSize = this.serialize().length;
        }

        this._size = this._links.reduce(function (sum, l) {
          return sum + l.Tsize;
        }, this._serializedSize);
      }

      return this._size;
    },
    set: function set(size) {
      throw new Error("Can't set property: 'size' is immutable");
    } // Getters for backwards compatible path resolving

  }, {
    key: "Data",
    get: function get() {
      return this._data;
    },
    set: function set(_) {
      throw new Error("Can't set property: 'Data' is immutable");
    }
  }, {
    key: "Links",
    get: function get() {
      return this._links.map(function (link) {
        return {
          Name: link.Name,
          Tsize: link.Tsize,
          Hash: link.Hash
        };
      });
    },
    set: function set(_) {
      throw new Error("Can't set property: 'Links' is immutable");
    }
  }]);

  return DAGNode;
}();

exports = module.exports = withIs(DAGNode, {
  className: 'DAGNode',
  symbolName: '@ipld/js-ipld-dag-pb/dagnode'
});